<aside class="sidebar">
  <div class="sidebar__scrollbar">
    <div class="sidebar__logo">
      <p (dblclick)="showVersion()" class="sidebar__logo-company" i18n>Мелитта</p>
      <p class="sidebar__logo-role" i18n>{{appMode | appModeTitle}}</p>
    </div>

    <nav class="sidebar__nav">
      <ul class="sidebar__nav-list primary-list">
        <ng-container *ngFor="let item of links$ | async">
          <li class="sidebar__nav-item">
            <a [ngClass]="'icon-' + item.className"
               [routerLink]="'cp/' + item.path"
               [attr.data-qa]="'sidebarLink-' + item.path"
               routerLinkActive="active">
              {{ item.title }}
            </a>
            <ng-container *ngIf="sidebarService.counters[item.counterName] | async as counter">
            <span class="sidebar__nav-counter" *ngIf="counter.value > 0">
              {{ counter.value > maxCounterValue ? '99+' : counter.value }}
            </span>
            </ng-container>
          </li>
        </ng-container>
      </ul>
      <ul class="sidebar__nav-list secondary-list">
<!--        <li class="sidebar__nav-item item-secondary" *ngFor="let item of secondaryLinks">-->
<!--          <a [routerLink]="item.path">{{ item.title }}</a>-->
<!--        </li>-->
        <li class="sidebar__nav-item item-secondary lang-select">
          <mat-select class="lang-select" (selectionChange)="setLang($event)" [(ngModel)]="currentLang"
                      panelClass="lang-select-panel">
            <mat-select-trigger>
              <div class="lang-select__option">
                <span class="lang-select__option-icon">
                  <img [src]="'/assets/images/sidebar-icons/lang-icon/' + currentLang + '.svg'" alt="">
                </span>
                <p class="lang-select__option-name">{{ currentLang | titlecase }}</p>
              </div>
            </mat-select-trigger>
            <mat-option [value]="lang.value" *ngFor="let lang of langLinks">
              <div class="lang-select__option">
                <span class="lang-select__option-icon">
                  <img [src]="'/assets/images/sidebar-icons/lang-icon/' + lang.value + '.svg'" alt="">
                </span>
                <p class="lang-select__option-name into-panel">{{ lang.title }}</p>
              </div>
            </mat-option>
          </mat-select>
          <div class="lang-select__icon">
            <img src="/assets/images/sidebar-icons/lang-icon/chevron-down.svg" alt="">
          </div>
        </li>
        <!-- todocheckprod -->
        <ng-container *ngIf="showDevSection">
          <button (click)="debug()">debug</button>
          <a routerLink="cp/dev">DEV</a>
          <li class="sidebar__nav-item item-secondary">
            <button (click)="changeModForDev(appModes.PRODUCER)">Producer</button>
            <button (click)="changeModForDev(appModes.DISTRIBUTOR)">Distr</button>
            <button (click)="changeModForDev(appModes.CLIENT)">Client</button>
          </li>
        </ng-container>
      </ul>
    </nav>
  </div>

  <div class="sidebar__user" *ngIf="currentUserService.currentUser$ | async as user">
    <figure class="sidebar__user-image">
      <!--      todocheckprod remove dblclick -->
      <img
        appProfileImage
        [appFileError]="user.picture?.uuid"
        [src]="user.picture?.url"
        alt="profile-photo"
        (dblclick)="toggleShowDevSection()"
      />
    </figure>
    <div class="sidebar__user-name">
      <p>{{ user.name }}</p>
      <p>{{ user.position }}</p>
    </div>
    <a class="sidebar__user-logout" routerLink="/auth/login"></a>
  </div>
</aside>

<app-modal-container *ngIf="showVersionModal">
  <app-modal-content [modalTitle]="'App version'" [hiddenButtons]="['success']"
                     (closeModal)="showVersionModal = false"
                     (successModal)="showVersionModal = false">
    <p *ngIf="version.pushMessage" class="gl-mar-b24">{{version.pushMessage}}</p>
    <p class="gl-mar-b24">{{version.buildMessage}}</p>
  </app-modal-content>
</app-modal-container>
